import { render, staticRenderFns } from "./InspectionSection.vue?vue&type=template&id=5a1b4ec2&scoped=true"
import script from "./InspectionSection.vue?vue&type=script&lang=ts"
export * from "./InspectionSection.vue?vue&type=script&lang=ts"
import style0 from "./InspectionSection.vue?vue&type=style&index=0&id=5a1b4ec2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1b4ec2",
  null
  
)

export default component.exports